export default __webpack_public_path__ + "d8f52a503f334e54f37d351e899737b7.jpg";